<template>
  <div id="app">
    <en-shortcut/>
    <div id="wrapper">
      <router-view></router-view>
    </div>
    <en-footer/>
    <div class="scrollBox" v-show="isShow" @click="scrollToTop">顶部 <i class="el-icon-arrow-up"></i></div>

  </div>
</template>

<script>
export default {
  name: 'full',
   data() {
    return {
      isShow: false, //控制返回顶部按钮的显隐
      scrollHeight: 0,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.updateScrollHeight);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateScrollHeight);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // 平滑滚动
      });
    },
    updateScrollHeight() {
      this.scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
      // console.log('this.scrollHeight', this.scrollHeight);
      if (this.scrollHeight > 500) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#wrapper {
      // background: linear-gradient(181deg,#dde0ee 0%, #efefef 100%);
          // background: #EFEFEF;

  margin: auto;
    // width: 1210px;//商家展示问题 然后 注释了
    min-height: 500px;
  min-height: calc(100vh - 31px - 219px);
}
/* 返回顶部样式 */
.scrollBox {
  position: fixed;
  right: 10px;
  bottom: 100px;
  font-size: 14px;
  // height: 30px;
  padding: 3px 5px;
  background-color: red;
  color: #fff;
  z-index: 990;
  cursor: pointer;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/full.vue